<template>
  <div>
    <flow-step-base
      name="Cancellation Confirmation"
      :guid="step.guid"
      :imgPath="img"
      description="Inform customers what they lose when they cancel."
      @disable="$emit('update', { enabled: false })"
      @rework="$emit('rework')"
    >
      <!-- @rework="$emit('rework')" -->
      <!-- <p class="mt-1 text-sm font-semibold leading-5 text-gray-700 mb-2">When will their account be cancelled?</p>
      <el-select
        :value="step.cancelSchedule"
        @change="(cancelSchedule) => $emit('update', { cancelSchedule })"
        placeholder="Select"
      >
        <el-option v-for="item in cancelTimeOptions" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <div class="mt-4">
        <p class="text-sm font-semibold mb-2 text-gray-700">What do you want this step to say?</p>
        <el-input
          type="text"
          placeholder="Headline"
          :value="step.header"
          @input="(header) => $emit('update', { header })"
          maxlength="80"
          show-word-limit
        >
        </el-input>
        <div style="margin: 20px 0"></div>
        <Editor :placeholder="step.description" :maxlength="0" @update="(description) => $emit('update', { description })" />
      </div>
      <div v-if="false" class="mt-4">
        <p class="text-sm font-semibold mb-2 text-gray-700">Require cancellation acknowledgement?</p>
        <el-switch
          :value="step.confirmConfig.requireAcknowledgement"
          @change="(requireAcknowledgement) => $emit('update', { requireAcknowledgement }, 'confirmConfig')"
          active-text="Yes"
          inactive-text="No"
        ></el-switch>
      </div>
      <div class="mt-4">
        <p class="text-sm font-semibold mb-2 text-gray-700 inline">
          Inform customers with active discounts that they will lose their discounts upon cancellation?
        </p>
        <el-tooltip effect="dark" placement="top" popper-class="brand-tooltip">
          <div slot="content" class="max-w-xs text-gray-100 text-sm">
            Note: You currently have a <span class="font-bold text-white">20% off for 2 months </span> discount valid until May 25th. If you cancel
            your subscription, you will lose this discount.
          </div>
          <p class="text-sm inline text-brand-blue font-semibold ml-1">Preview this feature</p>
          <!-- <font-awesome-icon :icon="['fas', 'info-circle']" class=" text-sm text-brand-medium-blue" /> -->
        </el-tooltip>
        <div class="mt-1">
          <el-switch
            :value="step.confirmConfig.discountNotice"
            @change="(discountNotice) => $emit('update', { discountNotice }, 'confirmConfig')"
            active-text="Yes"
            inactive-text="No"
          ></el-switch>
        </div>
      </div>
    </flow-step-base>
  </div>
</template>

<script>
import FlowStepBase from '@/components/FlowSteps/FlowStepBase.vue';
import Editor from '@/components/UI/Editor.vue';
import { CANCEL_SCHEDULE } from '@/store/shared';
import img from '@/assets/img/icon-confirmation.svg';

const cancelTimeOptions = [
  { value: CANCEL_SCHEDULE.PERIOD_END, label: 'End of Billing Period' },
  { value: CANCEL_SCHEDULE.IMMEDIATE, label: 'Immediately' },
];

export default {
  name: 'FlowStepCancelConfirm',
  components: {
    FlowStepBase,
    Editor,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cancelTimeOptions,
      img,
    };
  },
};
</script>
